import React from 'react';
import {Grid} from "@mui/material";

type GroupSummariesCardContainerProps = React.ComponentPropsWithoutRef<'div'>;

/**
 * Styled Grid component used with accompanying GroupSummaries components for title value paired groupings
 * @param props passthrough props to the internal Grid mui component
 * @constructor
 */
const GroupSummariesCardContainer = (props: GroupSummariesCardContainerProps) => {
  return <Grid container spacing={4} {...props} />
}

export { GroupSummariesCardContainer };
